// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/vant-css/index.css'
import axios from 'axios'
import store from './vuex/store'
import Vtip from 'vtip'
import 'vtip/lib/index.min.css'
import { restore } from './fetch/twocode';

Vue.prototype.restore = restore;
Vue.use(Vant)
Vue.config.productionTip = false
Vue.prototype.$http =axios;

Vue.use(Vtip.directive)
Vue.prototype.$tip = Vtip.tip

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js